export default __webpack_public_path__ + "static/commercial-banner-9862fbaf10259e09a091e2ee66af8bf6.png";